<div class="Customers overview-loyalty ui-g">

    <div class="ui-g-12 ui-lg-6">
        <h1 class="step-title">{{ translations.page_title }}</h1>
    </div>
    <div class="ui-g-12 ui-lg-12">
        <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="false"></p-steps>

        <div class="overview-container card ui-g-nopad">
            <app-assortimento-main-kpi [hidden]="activeIndex !== 0" ></app-assortimento-main-kpi>
        </div>

    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/store/assortimento/assortimento.component.html